cv.CustomFieldsFormView = Marionette.LayoutView.extend({
  template: cv.Templates['global/custom_fields_form/view'],

  events : {
    'click .edit-mode' : 'toggleMode',
    'click .edit-form' : 'editForm',
    'click .preview-form' : 'previewForm'
  },

  regions : {
    'custom_fields_form' : '.custom-fields-form'
  },

  behaviors: [{
    behaviorClass: cv.FormBehavior,
    suppress_notifications: true
  }],

  validation: {
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    // Set some defaults
    if(_.isUndefined(this.options.edit_mode)){
      this.options.edit_mode = false;
    }
    if(_.isUndefined(this.options.values)){
      this.options.values = {};
    }
    if(_.isUndefined(this.options.container)){
      this.options.container = null;
    }
    if(_.isUndefined(this.options.is_donation_form)){
      this.options.is_donation_form = false;
    }

    // Set up the default collection
    if(!_.isUndefined(this.options.custom_fields)){
      this.collection = new cv.CustomFieldGroups(this.options.custom_fields);
    }else{
      this.collection = new cv.CustomFieldGroups();
    }

    this.listenTo(vent, 'custom_field:edit_form', function(){
      this.$('.edit-form').addClass('active');
      this.$('.preview-form').removeClass('active');
      this.$('.custom-fields-form').addClass('custom-fields-edit-form');
      this.$('.custom-fields-form').removeClass('custom-fields-preview-form');
    }, this);
    this.listenTo(vent, 'custom_field:preview_form', function(){
      this.$('.edit-form').removeClass('active');
      this.$('.preview-form').addClass('active');
      this.$('.custom-fields-form').addClass('custom-fields-preview-form');
      this.$('.custom-fields-form').removeClass('custom-fields-edit-form');
    }, this);

    console.log('CustomFieldFormView initialized');
  },

  templateHelpers: function(){
    return {
      is_edit_mode : this.options.edit_mode
    }
  },

  previewForm: function(e){
    e.preventDefault();

    vent.trigger('custom_field:preview_form');
  },

  editForm: function(e){
    e.preventDefault();

    vent.trigger('custom_field:edit_form');
  },

  getValues: function(){
    var custom_values = {};

    console.log('models', this.collection.models);

    _.each(this.collection.models, function(group_model){
      if(group_model.get('type') == 'normal'){
        _.each(group_model.get('fields'), function(field_attributes){
          custom_values[field_attributes.id] = field_attributes['field_value_' + field_attributes.random_id];
        }, this);
      }else{
        // For each repeating field build an array to hold fields
        custom_values[group_model.get('id')] = [];

        _.each(group_model.get('fields'), function(nested_group_attributes){
          var group_field_value = {};
          _.each(nested_group_attributes.fields, function(field_attributes){
            group_field_value[field_attributes.id] = field_attributes['field_value_' + field_attributes.random_id];
          }, this);
          
          // Push it into the stack
          custom_values[group_model.get('id')].push(group_field_value);
        }, this);
      }
    }, this);

    return custom_values;
  },

  onAttach: function(){
    if(this.options.edit_mode == true){
      this.$el.addClass('custom-fields-edit-mode');
    }
    
    var view = new cv.CustomFieldGroupsView({
      collection : this.collection,
      edit_mode : this.options.edit_mode,
      values : this.options.values,
      container : this.options.container,
      type : this.options.type,
      is_donation_form : this.options.is_donation_form
    });

    // Link the custom form
    this.trigger('form:link', view);
    this.showChildView('custom_fields_form', view);
  },

  onDestroy: function(){
  }
});